export default {"src":"/_next/static/media/arrow-right-neighborhood-menu.0d6a587d.svg","height":22,"width":14,"blurWidth":0,"blurHeight":0};